import React from 'react';
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { CheckCircle, AlertCircle } from "lucide-react";

interface BrandVerificationBadgeProps {
  verified: boolean;
  relationshipType?: string;
  className?: string;
}

export function BrandVerificationBadge({ 
  verified, 
  relationshipType = "authorized_dealer",
  className = "" 
}: BrandVerificationBadgeProps) {
  const displayText = {
    'manufacturer': 'OEM',
    'authorized_dealer': 'Authorized Dealer',
    'distributor': 'Distributor',
    'service_partner': 'Service Partner',
    'reseller': 'Reseller',
    'other': 'Brand Partner'
  };

  const icon = verified ? <CheckCircle className="h-3 w-3 mr-1" /> : <AlertCircle className="h-3 w-3 mr-1" />;
  const label = displayText[relationshipType as keyof typeof displayText] || 'Brand Partner';
  
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge 
            variant={verified ? "default" : "outline"} 
            className={`flex items-center ${className}`}
          >
            {icon} {label}
          </Badge>
        </TooltipTrigger>
        <TooltipContent>
          {verified 
            ? `Verified ${label}. This supplier is officially recognized by the brand.` 
            : `Unverified ${label}. Verification pending.`}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
